import { createSlice } from '@reduxjs/toolkit'

const clientSlice = createSlice({
    name: 'client/state',
    initialState: {
        deleteConfirmation: false,
        selectedClient: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedClient: (state, action) => {
            state.selectedClient = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation, 
    setSortedColumn,
    setSelectedClient
} = clientSlice.actions

export default clientSlice.reducer
